module.exports = __webpack_public_path__ + "img/4.ccd8b9eb.jpg";